import { render } from "./NewActionBar.vue?vue&type=template&id=8fa82c5c&scoped=true&ts=true"
import script from "./NewActionBar.vue?vue&type=script&lang=ts"
export * from "./NewActionBar.vue?vue&type=script&lang=ts"

import "./NewActionBar.vue?vue&type=style&index=0&id=8fa82c5c&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa82c5c"]])

export default __exports__